export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="1em" height="1.08em" viewBox="0 0 23 25" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-25.000000, -997.000000)">
                    <g id="-mockplus-" transform="translate(0.000000, 114.000000)">
                        <g id="众筹信息模块/手机端" transform="translate(0.000000, 32.214047)">
                            <g id="time_icon" transform="translate(25.000000, 851.658863)">
                                <rect id="矩形" x="0" y="0" width="23" height="23.1538462" />
                                <ellipse id="椭圆形" stroke="#03060B" strokeWidth="1.79564" cx="11.5" cy="13.181665" rx="8.04662444" ry="8.10535448" />
                                <line x1="8.79703018" y1="1.66795128" x2="14.1606569" y2="1.66795128" id="路径-5" stroke="#03060B" strokeWidth="1.79564" />
                                <polyline
                                    id="路径-6"
                                    stroke="#03060B"
                                    strokeWidth="1.79564"
                                    strokeLinejoin="round"
                                    points="11.4787037 8.9373898 11.4787037 13.1495893 14.9709157 13.1495893"
                                />
                                <line x1="17.8509592" y1="4.4622478" x2="16.4747191" y2="6.77795617" id="路径-7" stroke="#03060B" strokeWidth="1.6324" />
                                <line x1="16.4814586" y1="3.77461524" x2="19.1229547" y2="5.31254707" id="路径-8" stroke="#03060B" strokeWidth="1.6324" />
                                <line x1="11.4787037" y1="2.16487903" x2="11.4787037" y2="4.4622478" id="路径-9" stroke="#03060B" strokeWidth="1.79564" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
